import * as types from "./types";
import { get } from "@zendesk/knowledge-http-client";
import { STAFF } from "../../constants";

const USER_SEGMENTS_URL = `/hc/api/v2/user_segments?multibrand=true&user_type=${STAFF}`;

function fetchUserSegmentsRequest() {
  return {
    type: types.FETCH_STAFF_USER_SEGMENTS_REQUEST,
  };
}

function fetchUserSegmentsSuccess(userSegments, page, pageCount) {
  return {
    type: types.FETCH_STAFF_USER_SEGMENTS_SUCCESS,
    userSegments,
    page,
    pageCount,
  };
}

function fetchUserSegmentsFailure(error) {
  return {
    type: types.FETCH_STAFF_USER_SEGMENTS_FAILURE,
    error: true,
    payload: error,
  };
}

export function fetchUserSegments(page) {
  return (dispatch, getState) => {
    dispatch(fetchUserSegmentsRequest());

    return get(`${USER_SEGMENTS_URL}&page=${page}`)
      .then(({ user_segments, page, page_count }) =>
        dispatch(fetchUserSegmentsSuccess(user_segments, page, page_count))
      )
      .catch(err => {
        dispatch(fetchUserSegmentsFailure(err));
        throw err;
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/staffUserSegments/index.js